import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'
import FeatherIcon from 'feather-icons-react';
import '../css/BoxItem.css'; // Tell webpack that Button.js uses these styles
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { withRouter, Link, NavLink } from 'react-router-dom';
import axiosConfig from '../config/axiosConfig'


class BranchBoxCard extends React.Component {
    constructor(props) {
        super(props);
        this.swalConfirm = this.swalConfirm.bind(this)
        this.BranchSelection = this.BranchSelection.bind(this)
    }

    BranchSelection(BranchID, BranchNumber, BranchName) {
        localStorage.setItem('selectedBranch', BranchID)
        localStorage.setItem('selectedBranchNumber', BranchNumber)
        localStorage.setItem('isBranchSelected', 'true')
        localStorage.setItem('selectedBranchName', BranchName)
        this.props.selectBranchHandler({ id: BranchID, Number: BranchNumber, Name: BranchName })

        axiosConfig.post('Portal/GetCardFee', {
            "UserBranchID": BranchID//this.props.data.selectedBranchId
        })
            .then((res) => {
                localStorage.setItem("IncrementalFee", JSON.stringify(res.data.cardFee.fee))
                localStorage.setItem("TotalFee", JSON.stringify(res.data.cardFee.currentFee))
                this.props.setCardFeeHandler({ TotalFee: res.data.cardFee.currentFee, IncrementalFee: res.data.cardFee.fee })
            })
            .catch(console.error)
            .finally(() => {

            });

        this.props.history.push("/")

    }

    swalConfirm() {

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire(
                    'Deleted!',
                    'Item has been deleted',
                    'success'
                )
            }
        })
    }

    render() {
        if (this.props.branchStatus == 'Active')
            return (
                <div class="d-flex justify-content-between btn box-item w-100 btn-accordian-items" onClick={() => this.BranchSelection(this.props.branchID, this.props.branchNumber, this.props.branchName)} >
                    <div>
                        <div >{this.props.branchName}</div>
                    </div>
                    <div>
                        <div>{this.props.branchNumber }</div>
                    </div>
                </div >
            )
        return (
            <div class="d-flex justify-content-between btn box-item w-100 btn-accordian-items-disabled">
                <div>
                    <div>{this.props.branchName}</div>
                </div>
                <div>
                    <div>{this.props.branchNumber}</div>
                </div>
            </div >
        )
    }
}

export default withRouter(BranchBoxCard);